// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","form":"_28NCFKsmNyvP","email":"_1PyMfL1QDqOD","phone__input":"_3KnvaN5KPQp0","email__input":"_1ijF82x-O7Nx","button":"kz0AOUE-8z5K"};